export const ADVANCE_SALES_STATUS = {
    PENDING: "pending",
    RUNNING: "running",
    PAID: "paid",
    CANCELLED: "cancelled",
  }
  